// Only one item MUST have the "default: true" key

module.exports = {
  de: {
    default: true,
    path: `/`,
    locale: `de-De`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `de`,
    ogLanguage: `de_DE`,
    defaultTitle: `rmDATA Produktinformationen`,
    defaultDescription: `rmDATA Produktinformationen`,
  },
  en: {
    path: `en`,
    locale: `en-US`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `en`,
    ogLanguage: `en_US`,
    defaultTitle: `rmDATA Producinformations`,
    defaultDescription: `rmDATA Produktinformationen`,
  },
  it: {
    path: `it`,
    locale: `it-IT`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `it`,
    ogLanguage: `it_IT`,
    defaultTitle: `rmDATA Producinformations`,
    defaultDescription: `rmDATA Producinformations`,
  },
  fr: {
    path: `fr`,
    locale: `fr-FR`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `fr`,
    ogLanguage: `fr_FR`,
    defaultTitle: `rmDATA Producinformations`,
    defaultDescription: `rmDATA Producinformations`,
  },
}
